import { rankMatchTemplates } from './matchers/rank-templates';
import { buildSectionByType } from './builders';
import { strategyRegistry } from './strategies';
import { deriveContentTags } from './utils';

const getTemplatesForSuggestion = (strategy, suggestionTags) => {
  for (const tag of suggestionTags) {
    if (strategy[tag] && Array.isArray(strategy[tag])) {
      return { templates: strategy[tag], matchedTag: tag };
    }
  }
  return { templates: strategy.matchTemplates, matchedTag: null };
};

export const resolveTemplate = (sectionCrawlData, sectionTemplates) => {
  const suggestion = sectionCrawlData;
  if (!suggestion) return null;

  const suggestionTags = deriveContentTags(suggestion);

  const strategy = strategyRegistry[suggestion.type_signal];
  if (!strategy) return null;

  const { templates: candidateTemplates, matchedTag } = getTemplatesForSuggestion(strategy, suggestionTags);

  const ranked = rankMatchTemplates(candidateTemplates, suggestionTags);

  if (!ranked.length) return null;

  const firstMatch = ranked[0];

  const active = buildSectionByType(firstMatch.type, sectionTemplates, suggestion, suggestionTags);
  if (!active) return null;

  return {
    ...active,
    _crawlMeta: {
      activeIndex: 0,
      suggestions: ranked,
      suggestionFields: suggestion,
      suggestionTags,
      matchedSpecialTag: matchedTag,
    },
  };
};
